import { Thermometer, Briefcase, BatteryFull, SpeakerSlash, ShieldCheck, Airplane } from "@phosphor-icons/react";

const FEATURES = [
  { icon: Thermometer, title: "Precise temperature", body: "Locked at a clinical 2–8°C with ±0.5°C accuracy." },
  { icon: Briefcase, title: "Portable", body: "Compact, TSA-friendly, fits any carry-on." },
  { icon: BatteryFull, title: "Battery powered", body: "Up to 10 hours unplugged per full charge." },
  { icon: SpeakerSlash, title: "Silent operation", body: "Whisper-quiet at under 28 dB." },
  { icon: ShieldCheck, title: "Medical-grade storage", body: "Sealed interior keeps vials sterile and dry." },
  { icon: Airplane, title: "Travel approved", body: "Airline, hotel and gym ready, anywhere you go." },
];

export default function FeaturesGrid() {
  return (
    <section
      id="features"
      data-testid="features-grid"
      className="py-14 sm:py-20 bg-white border-y border-[#8A97A8]/20"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="overline text-cyan-brand">Why CryoVault</div>
          <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-[54px] font-bold text-navy-deep tracking-tight leading-[1.05]">
            Built specifically for peptides.
          </h2>
        </div>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="reveal group relative overflow-hidden rounded-3xl backdrop-blur-xl border border-white/70 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-teal-brand/50 shadow-[inset_0_1px_0_rgba(255,255,255,0.75),0_10px_30px_-18px_rgba(2,47,107,0.15)] hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.9),0_20px_50px_-24px_rgba(2,47,107,0.25),0_0_36px_-6px_rgba(1,207,198,0.45)]"
              style={{
                backgroundImage:
                  "linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(240,247,251,0.65) 100%)",
              }}
            >
              <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-x-6 top-0 h-1/3 rounded-t-3xl bg-gradient-to-b from-white/70 to-transparent opacity-90"
              />
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -inset-y-2 -left-1/3 w-1/3 rotate-12 bg-gradient-to-r from-transparent via-white/60 to-transparent opacity-0 group-hover:opacity-100 group-hover:left-[110%] transition-all duration-700 ease-out"
              />
              <div className="relative z-[1] h-12 w-12 rounded-2xl bg-white border border-[#8A97A8]/25 grid place-items-center text-cyan-brand shadow-sm">
                <f.icon size={22} weight="regular" />
              </div>
              <h3 className="relative z-[1] mt-5 text-navy-deep font-display font-bold text-lg">
                {f.title}
              </h3>
              <p className="relative z-[1] mt-3 text-slate-600 leading-relaxed text-[14.5px]">
                {f.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
